import * as settingsStore from './store'

export function settingsModule({ store }) {
  store.registerModule('settings', { ...settingsStore, namespaced: true })
}
